import {useEffect, useState, useCallback} from '@wordpress/element';
import {useSelect, useDispatch} from '@wordpress/data';
import {STORE_KEY} from '@ppcp/block-data';

export const useCreateFastlane = ({paypal}) => {

    const fastlane = useSelect(select => {
        return select(STORE_KEY).getFastlane();
    });

    const {
        setFastlane,
    } = useDispatch(STORE_KEY);

    useEffect(() => {
        if (paypal && paypal.Fastlane) {
            paypal.Fastlane().then(result => {
                setFastlane(result);
            });
        }
    }, [paypal]);

    useEffect(() => {
        setFastlane(fastlane);
    }, []);

    return fastlane;
}